import React, { useContext } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { AuthContextProvider } from './context/AuthContext'
import Register from './components/Register'
import ScreeningForm from './components/ScreeningForm'
import Login from './components/Login'
import Report from './components/Report'
import './index.css'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'

const App = () => {
  return (
    <AuthContextProvider>
      <Router>
        <Route exact path='/' component={ScreeningForm} />
        <Route exact path='/register' component={Register} />
        <Route exact path='/admin/' component={Login} />
        <Route exact path='/admin/report' component={Report} />
      </Router>
    </AuthContextProvider>
  )
}

export default App;
